import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerCustomAlert: {
        flex: 1,
        backgroundColor: 'transparent',
    },
    loading: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        height: 50,
    },
    loadingImage: {
        backgroundColor: 'white',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        height: 200,
    },
})

export default styles
